/* global Shopify */
import { Product } from '../models/product'
import { SellingPlan } from '../models/selling-plan'
import { SellingPlanGroup } from '../models/selling-plan-group'
import { Variant } from '../models/variant'
import { checkStatus, parseJSON } from '../utils/ajax'
import { PriceAdjustment } from '../models/price-adjustments'
import {
  SellingPlanAllocation
} from '../models/selling-plan-allocation'
import { initWidgets } from '../container/widgets-container'

declare const SHOPIFY_BASE_URL: string

const baseUrl = SHOPIFY_BASE_URL || ''

const adaptSellingPlan = (sellingPlansResponse: any): SellingPlan => {
  return {
    id: sellingPlansResponse.id,
    description: sellingPlansResponse.description,
    name: sellingPlansResponse.name,
    options: sellingPlansResponse,
    priceAdjustments: resolvePriceAdjustments(sellingPlansResponse)
  }
}

function resolvePriceAdjustments (sellingPlansResponse: any): PriceAdjustment[] {
  return sellingPlansResponse.price_adjustments.map((price: any) => {
    return {
      valueType: price.value_type,
      value: price.value
    }
  })
}

const adaptSellingPlanGroup = (productPrice: number, variants: Variant[]) => (sellingPlanGroupResponse: any): SellingPlanGroup => {
  return {
    id: sellingPlanGroupResponse.id,
    name: sellingPlanGroupResponse.name,
    sellingPlans: sellingPlanGroupResponse.selling_plans.map(adaptSellingPlan),
    options: sellingPlanGroupResponse.options
  }
}

const adaptSellingPlanAllocations = (sellingPlanAllocation: any): SellingPlanAllocation => {
  return {
    groupId: sellingPlanAllocation.selling_plan_group_id,
    sellingPlanId: sellingPlanAllocation.selling_plan_id,
    price: sellingPlanAllocation.price
  }
}

const adaptVariants = (variantsResponse: any): Variant => {
  return {
    id: variantsResponse.id,
    title: variantsResponse.title,
    price: variantsResponse.price,
    sellingPlanAllocations: variantsResponse.selling_plan_allocations.map(adaptSellingPlanAllocations)
  }
}

const isYotpoSellingPlanGroup = (sellingPlanGroupResponse: any): boolean => {
  if (!sellingPlanGroupResponse.app_id) {
    return false
  }
  return sellingPlanGroupResponse.app_id.toLowerCase() === 'yotpo echo'
}

const adaptProductResponse = (response: any): Product => {
  const variants = response.variants.map(adaptVariants)
  return {
    id: response.id,
    description: response.description,
    handle: response.handle,
    title: response.title,
    price: response.price,
    requiresSellingPlan: response.requires_selling_plan,
    sellingPlanGroups: response.selling_plan_groups.filter(isYotpoSellingPlanGroup).map(adaptSellingPlanGroup(response.price, variants)),
    variants: variants,
    priceVaries: response.price_varies
  }
}

export const getProductInfo = (productHandle: string): Promise<Product> => {
  return fetch(`${baseUrl}/products/${productHandle}.js`)
    .then(checkStatus)
    .then(parseJSON)
    .then(adaptProductResponse)
}

export const ensureWidgetInEditorMode = () => {
  // @ts-ignore
  if (typeof (Shopify) !== 'undefined' && Shopify.designMode) {
    const interval = setInterval(() => {
      const widgetElement = document.querySelector('.yotpo-widget-subscriptions-add-to-cart')
      if (!widgetElement) {
        initWidgets()
        clearInterval(interval)
      }
    }, 3000)
  }
}
